export default __webpack_public_path__ + "static/media/play-icon.433e1b85.svg";